import { Box } from '../Layout'
import { OldText } from '../Typography'
import { AnimatedLabel } from './AnimatedLabel'
import React, { FC } from 'react'
import { GridColumnProps, MarginBottomProps, MarginTopProps } from 'styled-system'

export type FieldControlProps = MarginBottomProps &
  MarginTopProps &
  GridColumnProps & {
    label?: React.ReactNode
    field: string
    assistiveText?: string
    errorMsg?: string
    htmlFor?: string
  }

export const FieldControl: FC<FieldControlProps> = ({
  label,
  assistiveText,
  errorMsg,
  children,
  field,
  mb = '1.5rem',
  htmlFor,
  ...rest
}) => {
  return (
    <Box {...rest} mb={mb}>
      {['input', 'textarea'].includes(field) ? (
        <Box position="relative">
          {children}
          {label && <AnimatedLabel htmlFor={htmlFor}>{label}</AnimatedLabel>}
        </Box>
      ) : (
        children
      )}
      {errorMsg ? (
        <OldText as="div" variant="micro" mt=".5rem" mb={0} color="error">
          {errorMsg}
        </OldText>
      ) : assistiveText ? (
        <OldText
          as="div"
          variant="micro"
          mt=".5rem"
          mb={0}
          color="shades.500"
          pl={['checkbox', 'radio'].includes(field) ? '2rem' : 0}
        >
          {assistiveText}
        </OldText>
      ) : null}
    </Box>
  )
}

FieldControl.defaultProps = {
  mb: 3,
}
